import { pipe } from 'fp-ts/lib/function';
import { useMemo } from 'react';
import { groupByAprValuesAndFee, type GroupedByAprAndFee } from 'utils';
import { useFinanceOptionsContext } from '../context';

export interface RegulatedRatesHook {
  rates: GroupedByAprAndFee | undefined;
  hasRates: boolean;
  hideNoRates: boolean;
}

export default function useRegulatedRates(): RegulatedRatesHook {
  const { rates: allRates, hideNoRates } = useFinanceOptionsContext();

  const rates = useMemo(() => {
    if (!allRates) return undefined;
    return pipe(allRates, groupByAprValuesAndFee);
  }, [allRates]);

  const hasRates = useMemo(() => {
    if (!rates) return false;
    return Object.keys(rates).length > 0;
  }, [rates]);

  return {
    rates,
    hasRates,
    hideNoRates,
  };
}
